import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import vueCountryRegionSelect from 'vue-country-region-select'
import VueSanitize from 'vue-sanitize'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
// import icon style(s)
import { fas } from '@fortawesome/pro-solid-svg-icons'
import { far } from '@fortawesome/pro-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import * as Sentry from '@sentry/vue'

import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

Sentry.init({
  Vue,
  dsn: 'https://1587e85034c45618647d08815e8f3e7d@o4509730059911168.ingest.us.sentry.io/4510677378793472',
  integrations: [
    // Or omit `router` if you're not using vue-router
    Sentry.browserTracingIntegration({ router }),
  ],
  environment: (() => {
    if (window.location.href.includes('localhost')) return 'development'
    if (window.location.href.includes('staging')) return 'staging'
    return 'production'
  })(),
  beforeSend(event) {
    // if (event.exception) {
    //   Sentry.showReportDialog({ eventId: event.event_id })
    // }

    // Modify the event here
    return event
  },
})

// Axios Mock Adapter
// import '@/@fake-db/db'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Composition API
Vue.use(VueCompositionAPI)

// locality select
Vue.use(vueCountryRegionSelect)

// vue-sanitize
Vue.use(VueSanitize)

// set window as global property
Vue.prototype.$window = window

/* add icons to the library */
library.add(fas, far, fab)
/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
